import { useRouter } from "next/router";

export function FilterComponent({
  filterTypeDataSet,
  filteractive,
  selectedCode,
  selectedFilterData,
  onFilterClick,
  data,
  onListClick,
  StatePlant,
}) {
  const router = useRouter();
  return (
    <div className="pro-filter-row">
      {/* proxy filters */}
      <ul className="add_cls nopin">
        {filterTypeDataSet?.map((val, index) => {
          const imageName = `/${val.toLowerCase()}.png`;

          return (
            <li
              key={index}
              className={
                filteractive === index
                  ? "filter-active-cls"
                  : "filter-inactive-cat"
              }
              onClick={onListClick(val, index)}
            >
              <div className="flt-type-img">
                <img src={imageName} alt="" />
              </div>
              <h6>{val === "Floor" ? "Wall/Floor" : val}</h6>

              <div className="filters-by open-filter">
                <ul className={selectedCode === "colors" ? "color-row" : ""}>
                  {selectedCode === "tile_factory_production" &&
                  data?.regionData?.state
                    ? selectedFilterData
                        .filter((cc) =>
                          StatePlant[data.regionData.state]?.includes(cc.value)
                        )
                        .map((obj, index) =>
                          router.query[selectedCode] === obj.key ? (
                            <li
                              style={{
                                background: "#939393",
                                color: "white",
                              }}
                              key={index}
                              className={
                                selectedCode === "colors" ? obj.value : ""
                              }
                            >
                              {obj.value}
                            </li>
                          ) : (
                            <li
                              key={index}
                              onClick={() => onFilterClick(obj.key, obj.value)}
                            >
                              {obj.value}
                            </li>
                          )
                        )
                    : selectedFilterData?.map((obj, index) =>
                        router.query[selectedCode] === obj.key ? (
                          <>
                            <li
                              style={{
                                background: "#939393",
                                color: "white",
                              }}
                              key={index}
                              className={
                                selectedCode === "colors" ? obj.value : ""
                              }
                            >
                              {selectedCode === "colors" && (
                                <span className="color-option"></span>
                              )}
                              {obj.value}
                            </li>
                            {index === 4 && (
                              <div
                                className="popular-sparater"
                                key={`sep-${index}`}
                              ></div>
                            )}
                          </>
                        ) : (
                          <>
                            <li
                              key={index}
                              className={
                                selectedCode === "colors" ? obj.value : ""
                              }
                              onClick={() => onFilterClick(obj.key, obj.value)}
                            >
                              {selectedCode === "colors" && (
                                <span className="color-option"></span>
                              )}
                              {obj.value}
                            </li>
                            {index === 4 && (
                              <div
                                className="popular-sparater"
                                key={`sep-${index}`}
                              ></div>
                            )}
                          </>
                        )
                      )}
                </ul>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
